import { Content } from '@visikon/core-models';
import { getTranslation } from '@visikon/core-models/typeUtils';
import { RouteComponentProps } from 'react-router';
import { useFirstValidContentConfig, useLanguage, useWholeContent } from '../../common/selectors';
import { useGetRootReDirector } from '../../components/MainContent';
import { isUrlType, MitforlobContent } from '../../reducers/resourcesReducer';
import { PhampletView } from './PhampletView';
type OwnProps = RouteComponentProps<{ textId?: string }>;

export const PhampletViewRoute = (props: OwnProps) => {
  const content = useWholeContent() as MitforlobContent;
  const firstValidContentConfig = useFirstValidContentConfig();

  if (!firstValidContentConfig) {
    return null;
  }

  const redirect = () => {
    return useGetRootReDirector();
  };

  if (!content || Object.keys(content).length === 0 || !content.phamplets) {
    return redirect();
  }
  const textList = content.phamplets?.data.textList;
  const relevantDocument = textList.find((text) => !isUrlType(text.text) && text.text._id === props.match.params.textId);
  if (!relevantDocument) {
    console.log('Relevant document not found');
    return redirect();
  }

  const index = textList.findIndex((text) => text.text._id === props.match.params.textId);

  const language = useLanguage();
  const textResult = getTranslation(relevantDocument.text as Content.Text, language);
  if (!textResult) {
    console.log("Relevant document didn't contain correct translation");
    return redirect();
  }

  return (
    <PhampletView
      documentId={relevantDocument.text._id}
      language={textResult.language}
      text={(textResult?.content as any).document}
      title={relevantDocument.textTitle}
      index={index}
    />
  );
};
